class VgGtm {

	static pushRegisterEventToDataLayer(eventName, dataEcommerce = {}, data = {}) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ ecommerce: null });

		const eventData = {
			event: eventName,
		};

		if (dataEcommerce && Object.keys(dataEcommerce).length !== 0) {
			eventData.ecommerce = dataEcommerce;
		}

		if (data) {
			for (const [key, value] of Object.entries(data)) {
				eventData[key] = value;
			}
		}

		eventData['custom_campaign'] = sessionStorage.getItem('vg_utm_campaign');

		let conversion = sessionStorage.getItem('vg_utm_conversion');
		if ( conversion === 'true' ) {
			sessionStorage.removeItem('vg_utm_campaign');
			sessionStorage.removeItem('vg_utm_conversion');
			sessionStorage.removeItem('vg_utm_product_name');
		}

		window.dataLayer.push(eventData);
		console.log("gtm-tracking: Pushing data to GTM:", { eventData  });
	}

	static async sha256(message) {
		const encoder = new TextEncoder();
		const data = encoder.encode(message);
		const hashBuffer = await crypto.subtle.digest('SHA-256', data);
		const hashArray = Array.from(new Uint8Array(hashBuffer));
		return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
	}

	static formatGtmLabel(label) {
		return label
			.trim()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(/[^\w\s]/g, '')
			.replace(/\s+/g, '_')
			.toLowerCase();
	}

	static formatGtmLabelSafe(label) {
		if (typeof label !== 'string') return '';
		return this.formatGtmLabel(label);
	}

	/**
	 * Checks if the page already has its own form listener
	 * @returns {boolean}
	 */
	static hasPageLevelLeadFormListener() {
		const classList = document.body?.classList;
		if (!classList) return false;

		return classList.contains('home') || classList.contains('single-vg_gym');
	}

	/**
	 * Hash a value for GTM (synchronous version)
	 * @param {string} value 
	 * @returns {Promise<string>}
	 */
	static async hashValueForGTM(value) {
		if (!value) return '';
		return await this.sha256(value);
	}

	/**
	 * Sends the form event to the dataLayer
	 * @param {Object} detail - Event details (success, gtm_data, error)
	 * @param {string} eventCategory - Event category ('tablet_lead' or 'newsletter_tbc')
	 */
	static sendLeadFormToDataLayer(detail, eventCategory) {
		const gtmData = detail?.gtm_data || {};
		
		const eventBaseData = {
			event_category: eventCategory,
			club_name: this.formatGtmLabelSafe(gtmData.club_name),
			club_region: this.formatGtmLabelSafe(gtmData.club_region),
		};

		// Add activity only if it exists (for TBC)
		if (gtmData.club_activity) {
			eventBaseData.club_activity = this.formatGtmLabelSafe(gtmData.club_activity);
		}

		if (!detail?.success) {
			this.pushRegisterEventToDataLayer('form_interaction', {}, {
				...eventBaseData,
				event_detail: 'envio_ko',
				event_label: detail?.error || 'error_interno',
			});
			return;
		}

		const successData = {
			...eventBaseData,
			event_detail: 'envio_ok',
			event_label: 'envio_ok',
		};

		if (gtmData.email_hashed) {
			successData.email_hashed = gtmData.email_hashed;
		}
		if (gtmData.phone_hashed) {
			successData.phone_hashed = gtmData.phone_hashed;
		}

		this.pushRegisterEventToDataLayer('form_interaction', {}, successData);
	}

	/**
	 * Emits the custom event and optionally sends to dataLayer
	 * @param {Object} detail - Event details (success, gtm_data, error)
	 * @param {string} eventCategory - Event category ('tablet_lead' or 'newsletter_tbc')
	 */
	static emitLeadFormSubmit(detail, eventCategory) {
		// Emit the custom event
		document.dispatchEvent(new CustomEvent("gtmLeadFormSubmit", { detail }));

		// If the page already has its own listener, we don't send to dataLayer
		if (this.hasPageLevelLeadFormListener()) {
			return;
		}

		// Send to dataLayer using the existing method
		this.sendLeadFormToDataLayer(detail, eventCategory);
	}
}